import React from "react";
import { Flex, Title, Button, Text, Badge } from "@mantine/core";
import styles from "@scss/custom-components/dataset-title-card.module.scss";

type CwiggoRaceTitleCardProps = {
  title: string;
  variant: "live" | "completed" | "upcoming" | "replaying";
  elapsedTime?: string | React.ReactNode;
};

export function CustomDatasetTitleCard({
  title,
  variant,
  elapsedTime,
}: CwiggoRaceTitleCardProps) {
  const renderRightSide = () => {
    switch (variant) {
      case "live":
        return (
          <Flex align="center" gap="sm">
            <Text size="xs">Elapsed:</Text>
            <Text size="xs" variant="flamingo">
              {elapsedTime}
            </Text>
            <Badge
              variant="flamingo-glow-icon"
              leftSection={<></>}
            >
              Live
            </Badge>
          </Flex>
        );

      case "completed":
        return (
          <Flex align="center" gap="sm">
            <Text size="sm" variant="orchid" fw="bold">
              [Completed]
            </Text>
            <Button size="sm">Replay data</Button>
          </Flex>
        );

      case "replaying":
        return (
          <Button variant="ghost" className={styles.replayButton}>
            <Flex align="center" gap="sm">
              <Badge
                variant="carrot-glow-icon"
                className={styles.replayBadge}
                classNames={{
                  section: styles.replayBadgeSection,
                  label: styles.replayBadgeLabel,
                }}
                leftSection={
                  <></>
                }
              >
                Replaying{" "}
                <></>
              </Badge>
            </Flex>
          </Button>
        );

      case "upcoming":
      default:
        return (
          <Text size="sm" variant="grey-400">
            [Upcoming]
          </Text>
        );
    }
  };

  return (
    <Flex
      justify="space-between"
      align="center"
      p="md"
      className={styles.datasetTitleCard}
    >
      <Title order={2}>{title}</Title>
      {renderRightSide()}
    </Flex>
  );
}

export default CustomDatasetTitleCard;
